import React from "react";

import { StoryCard } from "../basic/story-card.js"
import { MediaObjectsList } from "../basic/media-object-list.js"
import { CollectionName } from "../basic/collection-name.js";

function CardGroup(props) {
  const majorStoryCardConfig = {
    subheadline: false,
    image: true,
    transparent: true
  };
  return (
    <div className=" component-wrapper card-group">
        <CollectionName name={props.config['collection-name']} type="large" section={props.config['collection-section']}/>
        <div className="card-container">
        <div className="hero-card">
          <StoryCard hideSectionName={true} story={props.stories[0]} config={majorStoryCardConfig}/>
        </div>
        <div className="other-cards">
          <StoryCard hideSectionName={true} story={props.stories[1]}/>
          <StoryCard hideSectionName={true} story={props.stories[2]}/>
          <StoryCard hideSectionName={true} story={props.stories[3]}/>
        </div>
      </div>
    </div>
  )
}


export { CardGroup };
